import React, { useState, useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Contact.css";
import L from "leaflet";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

function Contact() {
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const nameRef = useRef();
  const emailRef = useRef();
  const messageRef = useRef();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!privacyAccepted) {
      alert("Bitte bestätige die Datenschutzerklärung.");
      return;
    }

    const name = nameRef.current.value;
    const email = emailRef.current.value;
    const message = messageRef.current.value;

    try {
      const res = await fetch("https://www.vfb-johannesberg.de/contact.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, message }),
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.message || "Unbekannter Fehler");

      alert("Nachricht erfolgreich versendet!");
      nameRef.current.value = "";
      emailRef.current.value = "";
      messageRef.current.value = "";
      setPrivacyAccepted(false);
    } catch (err) {
      alert("Fehler beim Senden: " + err.message);
    }
  };

  return (
    <section className="contact-container">
      <div className="container">
        <div className="row justify-content-center">
          <h1 className="main-headline mb-4 text-center">Kontakt</h1>
          <div className="col-lg-10">
            <div className="contact-card row shadow rounded p-4">
              <div className="col-md-6 contact-info">
                <h2><i className="fas fa-comments"></i> Kontakt</h2>
                <p className="contact-subtitle">Wir freuen uns auf deine Nachricht.</p>

                <div className="contact-detail mb-3">
                  <i className="fas fa-user"></i>
                  <div>
                    <h4>1. Vorsitzender</h4>
                    <p>Karsten Seilius</p>
                  </div>
                </div>

                <div className="contact-detail mb-3">
                  <i className="fas fa-map-marker-alt"></i>
                  <div>
                    <h4>Adresse</h4>
                    <p>Douglasienweg 2<br />36251 Bad Hersfeld</p>
                    <p>Eibenweg 13 (Postadresse)</p>
                  </div>
                </div>

                <div className="contact-detail mb-3">
                  <i className="fas fa-phone"></i>
                  <div>
                    <h4>Telefon</h4>
                    <p><a href="tel:01717924528">0171-7924528</a></p>
                  </div>
                </div>

                <div className="contact-detail mb-3">
                  <i className="fas fa-envelope"></i>
                  <div>
                    <h4>E-Mail</h4>
                    <p><a href="mailto:info@vfb-johannesberg.de">vfb-johannesberg@web.de</a></p>
                  </div>
                </div>

                <div className="contact-map mt-4">
                  <MapContainer center={[50.84701650465196, 9.702037275335845]} zoom={12} scrollWheelZoom={false} style={{ height: "300px", width: "100%" }}>
                    <TileLayer
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    />
                    <Marker position={[50.847057292822, 9.70205916528197]}>
                      <Popup>VfB Johannesberg e.V.</Popup>
                    </Marker>
                  </MapContainer>
                </div>
              </div>

              <div className="col-md-6 contact-form">
                <h2><i className="fas fa-pencil-alt"></i> Schreib uns</h2>
                <p className="contact-subtitle">Lass uns eine Nachricht da.</p>

                <form onSubmit={handleSubmit}>
                  <div className="form-group mb-3">
                    <input type="text" className="form-control" placeholder="Dein Name" required ref={nameRef} />
                    <i className="fas fa-user input-icon"></i>
                  </div>

                  <div className="form-group mb-3">
                    <input type="email" className="form-control" placeholder="Deine E-Mail" required ref={emailRef} />
                    <i className="fas fa-envelope input-icon"></i>
                  </div>

                  <div className="form-group mb-3">
                    <textarea className="form-control" placeholder="Deine Nachricht" rows="4" required ref={messageRef}></textarea>
                    <i className="fas fa-comment-dots input-icon"></i>
                  </div>

                  <div className="custom-checkbox-container mt-3">
                    <label htmlFor="privacyCheck" className="custom-checkbox-label">
                      <input
                        type="checkbox"
                        id="privacyCheck"
                        checked={privacyAccepted}
                        onChange={(e) => setPrivacyAccepted(e.target.checked)}
                        required
                      />
                      <span
                        className="checkmark"
                        style={{
                          borderColor: privacyAccepted ? "#007bff" : "#ccc",
                          backgroundColor: privacyAccepted ? "#007bff" : "transparent",
                        }}
                      ></span>
                      <span className="checkbox-text">
                        Ich habe die{" "}
                        <a href="/datenschutz" target="_blank" rel="noopener noreferrer">
                          Datenschutzerklärung
                        </a>{" "}
                        zur Kenntnis genommen.
                      </span>
                    </label>
                  </div>

                  <button type="submit" className="btn btn-primary mt-3" disabled={!privacyAccepted}>
                    <i className="fas fa-paper-plane"></i> Absenden
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
